module.exports = __webpack_public_path__ + "img/weareontop.66931674.gif";